import angular from 'angular';

import LocationEventConstant from './LocationEventConstant';
import CustomMarkerService from './CustomMarkerService';
import EventMarkerService from './EventMarkerService';
import EquipmentMapComponent from './EquipmentMapComponent';

import './markerAnimate';

export default angular
  .module('petroCloud.dashboard.equipmentMapPanel', [])
  .constant('LocationEventConst', LocationEventConstant)
  .service('CustomMarkerService', CustomMarkerService)
  .service('EventMarkerService', EventMarkerService)
  .component(EquipmentMapComponent.name, EquipmentMapComponent)
  .name;
